import { Component, Input, SimpleChanges, AfterViewInit } from '@angular/core';
import * as Highcharts from 'highcharts';
import HC_accessibility from 'highcharts/modules/accessibility';
import { HttpClient } from '@angular/common/http';
import { PiechartService } from '../../piechart.service';
import { Observable, Subscription } from 'rxjs';
import { CustomsnapshotService } from 'src/app/modules/snapshot/Services/customsnapshot.service';
import { ActivatedRoute, Router } from '@angular/router';
import { COMMON_CONSTANTS, COMMON_CONSTANTS_Percentage, COMMON_CONSTANTS_SNAPSHOT } from 'src/app/common/constants/common-constants';
import { SnapshotService } from 'src/app/modules/snapshot/Services/snapshot.service';
import { InsightspopupService } from 'src/app/common/services/insightspopup.service';
import * as _ from 'lodash';
import { SignificanceService } from 'src/app/common/services/significance.service';

@Component({
  selector: 'app-piechart11-custom',
  templateUrl: './piechart11.component.html',
  styleUrls: ['./piechart11.component.css'],
  host: {
    '[class.popup-mode]': 'popUp'
  },
  // styles: [`
  //   :host:not(.popup-mode) ::ng-deep .highcharts-t5nngmp-381 {
  //     height: auto !important;
  //     min-height: 300px !important;
  //   }
  //   :host:not(.popup-mode) ::ng-deep [class*="highcharts-"] {
  //     height: auto !important;
  //   }
  //   :host:not(.popup-mode) ::ng-deep .highcharts-container {
  //     height: 100% !important;
  //   }
  //   :host:not(.popup-mode) ::ng-deep .layout {
  //     height: 100%;
  //     width: 100%;
  //   }
  // `]
})
export class Piechart11ComponentCustom implements AfterViewInit {
  constructor(
    private http: HttpClient,
    private piechartservice: PiechartService,
    private _customSnapshotService: CustomsnapshotService,
    private router: Router,
    private route: ActivatedRoute,
    private _configService: SnapshotService,
    public _insightsSerive: InsightspopupService,
    private significanceService: SignificanceService
  ) {
  }

  // Getter for insights open state
  get insightsOpen(): boolean {
    return this._insightsSerive.insightsopen;
  }
  
  // Method to update heights based on insights state
  private updateHeights(): void {
    if (this._insightsSerive.insightsopen) {
      this.containerHeight = '11rem';
      this.chartHeight = '11rem';
    } else {
      this.containerHeight = '11em';
      this.popUp ? this.chartHeight = '30rem' : this.chartHeight = '100%';
    }
    this.updateChartContainerClasses();
    // Dynamically update legend y position without full re-render
    if (this.chart) {
      const isOpen = this._insightsSerive.insightsopen;
      // Apply only if legend exists
      this.chart.update({
        legend: {
          y: isOpen ? 0 : (this.chartproperties?.legendPosition === 'bottom' ? (this.popUp ? -35 : -50) : -30)
        }
      }, false); // defer redraw until after potential other updates
      this.chart.redraw();
    }
  }
  
  // Method to update chart container CSS classes based on insights state
  private updateChartContainerClasses(): void {
    const chartContainer = document.getElementById('chart-container' + this.id);
    if (chartContainer) {
      if (this._insightsSerive.insightsopen) {
        chartContainer.classList.add('insights-open');
      } else {
        chartContainer.classList.remove('insights-open');
      }
    }
  }
  jsondata: any;
  seriescolor: any;
  seriesgradientcolor: any;
  chartproperties: any;
  samplesizeconstant: any;
  chartimagepath: any;
  userselectedchartdata: any;

  //parameters from snapshot-chrtparent

  @Input() gridTempleteColumns: any;
  @Input() popUpp: any;
  @Input() popUp: any;
  @Input() customData: any;
  @Input() id: any = 0;
  @Input() sort: any;
  @Input() WidgetDetails: any;
  @Input() height: any  ;
  @Input() isOutput: any;
  maxDataPoints: any = 2;
  significanceValue: any = "None";
  chartMainData: any = [];
  Sig_LowerLimt = COMMON_CONSTANTS.SigLowerLimit_95;
  Sig_UpperLimt = COMMON_CONSTANTS.SigUpperLimit_95;
  DefaultConfidenceLevel: any = "";
    hasCustomMetricIndex = false;
  hasCustomMetricSignificance = false;
  hasCustomMetricPercentage = false;
  // Multi-cohort properties
  cohorts: any[] = [];
  isMultiCohort: boolean = false;
  sharedLegendChart: any; // Store the shared legend chart
  globalColorMapping: Map<string, string> = new Map(); // Store consistent colors for categories

  private subscriptions: Subscription = new Subscription();
  configuredProperties: any;
  
  // Height properties for template binding
  containerHeight: string = '11em';
  chartHeight: string = '100%';
  innerCircleDisplayValue: string | null = null;
  innerCircleLabel: string | null = null;
  innerMetricObj: any = null;
  innerCircleName: string | null = null;
  innerCircleSigText: string | null = null;
  innerCircleSigColor: string = 'black';
  innerAudienceObj: any = null;
  innerCircleAudienceName: string | null = null;

  ngOnInit(): void {
    // Initialize insights state and set up subscription
    this.updateHeights();
    
    // Subscribe to insights service changes to update heights dynamically
    this.subscriptions.add(
      this._insightsSerive.isInsightsSnapshot$.subscribe((insights) => {
        // Update the insightsopen property when insights show/hide
        if (insights) {
          this._insightsSerive.insightsopen = insights.show;
          this.updateHeights();
        }
      })
    );
    
    // Also subscribe to the regular insights observable
    this.subscriptions.add(
      this._insightsSerive.isInsights$.subscribe((insights) => {
        if (insights) {
          this._insightsSerive.insightsopen = insights.show;
          this.updateHeights();
        }
      })
    );
    
    if (this.isOutput) {
      
      this.configuredProperties = JSON.parse(this.customData.customizationProperties);
      this.applyCustomMetricExtensions();
      // Check if this is a multi-cohort scenario
      this.checkMultiCohort();
      
      if (!this.isMultiCohort) {
        // Single chart logic
        this.innerMetricObj = this.customData.metric?.find((m: any) => m.isInnerCircle === true || m.metric_option === 'Metric Inner Circle : ') ?? null;
        const innerData = this.innerMetricObj?.metric_value?.[0]?.data?.[0] ||
        this.innerAudienceObj?.data?.[0];
        if (innerData?.rowChild) {
          const parts = innerData.rowChild.split('|').map((p: string) => p.trim());
          this.innerCircleName = parts[parts.length - 1];
        } else {
          this.innerCircleName =
            this.innerMetricObj?.metric_value?.[0]?.option ?? null;
        }
        this.innerAudienceObj = this.customData.metric?.[0]?.metric_value?.find((mv: any) => mv.isInnerCircle === true) ?? null;
        this.innerCircleAudienceName = this.innerAudienceObj?.option ?? null;
        if (!this.innerCircleName && this.innerCircleAudienceName) {
          this.innerCircleName = this.innerCircleAudienceName;
        }
        this.customData = this.customData.metric[0];
        this.customData.metric_value.sort((a: any, b: any) => a.selectorder - b.selectorder);
      }
      
      this.maxDataPoints = this.popUp ? 6 : this.maxDataPoints;
      this.subscriptions.add(
        this._configService.confedenceValue.subscribe(value => {
          this.DefaultConfidenceLevel = value;
          this.updateSig();
        }));
      this.subscriptions.add(
        this._configService.significanceValue.subscribe(value => {
          this.significanceValue = value;
          this.updateSig();
        }));
    }
    else {
      this.http.get<any>('assets/Data/piechart.json').subscribe((data) => {
        this.jsondata = data[0];
        this.chartproperties = this.jsondata['properties'][0];
        this.chartproperties.showLegend = true;
        this.chartproperties.legendPosition = "bottom";
        this.chartproperties.decimalRoundOff = 2;
        this.seriescolor = this.piechartservice.color;
        this.seriesgradientcolor = this.piechartservice.linearGradients1;
        this.chartimagepath = this.piechartservice.chartimagepath;
        this.samplesizeconstant = this.piechartservice.samplesizeconstant
        // this.plotChart('chart-container'+this.id,this.jsondata['data'], this.chartproperties);
        this.route.paramMap.subscribe((params) => {
          const userData = history.state.userData;
          this.userselectedchartdata = userData; // Use the userData object as needed
          if (this.userselectedchartdata?.widgetEditSelection) {
            if (this.userselectedchartdata?.widgetEditSelection?.customizationProperties != "") {
              this.chartproperties = JSON.parse(this.userselectedchartdata?.widgetEditSelection?.customizationProperties);
            }
          }
        });
        this.plotChart('chart-container' + this.id, this.jsondata['data'], this.chartproperties);
      });
    }
  }
 private applyCustomMetricExtensions(): void {

    const metrics = this.customData?.metric_value || [];

    this.hasCustomMetricIndex = false;
    this.hasCustomMetricSignificance = false;
    this.hasCustomMetricPercentage = false;

    metrics.forEach((metric: any) => {

      const extensions = metric.extensionOptions || [];

      if (
        extensions.some((e: any) =>
          e.id === 'index' && e.selected
        )
      ) {
        this.hasCustomMetricIndex = true;
      }

      if (
        extensions.some((e: any) =>
          e.id === 'significance' && e.selected
        )
      ) {
        this.hasCustomMetricSignificance = true;
      }

      if (
        extensions.some((e: any) =>
          e.id === 'percentageSymbol' && e.selected
        )
      ) {
        this.hasCustomMetricPercentage = true;
      }
    });


  }
  ngOnChanges(changes: SimpleChanges): void {
    // Update heights when insights state changes
    this.updateHeights();
    
    if (changes['customData'] && !changes['customData'].firstChange) {
      if (this.isOutput) {
        this.configuredProperties = JSON.parse(this.customData.customizationProperties);
        this.checkMultiCohort();
        if (!this.isMultiCohort) {
          this.innerMetricObj = this.customData.metric?.find((m: any) => m.isInnerCircle === true || m.metric_option === 'Metric Inner Circle : ') ?? null;
          const innerData = this.innerMetricObj?.metric_value?.[0]?.data?.[0] ||
          this.innerAudienceObj?.data?.[0];
          if (innerData?.rowChild) {
            const parts = innerData.rowChild.split('|').map((p: string) => p.trim());
            this.innerCircleName = parts[parts.length - 1];

          } else {
            this.innerCircleName =
              this.innerMetricObj?.metric_value?.[0]?.option ?? null;
          }
          this.innerAudienceObj = this.customData.metric?.[0]?.metric_value?.find((mv: any) => mv.isInnerCircle === true) ?? null;
          this.innerCircleAudienceName = this.innerAudienceObj?.option ?? null;
          if (!this.innerCircleName && this.innerCircleAudienceName) {
            this.innerCircleName = this.innerCircleAudienceName;
          }
          this.customData = this.customData.metric[0];
          this.customData.metric_value.sort((a: any, b: any) => a.selectorder - b.selectorder);
        }
        this.updateSig();
      }
    }
  }
  
  ngAfterViewInit(): void {
    if (this.isOutput && this.isMultiCohort) {
      // Render all cohort charts after view init
      setTimeout(() => {
        this.updateSig();
      }, 100);
    }
  }
  
  // Check if this is multi-cohort based on data structure
  checkMultiCohort(): void {
  
    if ( this._configService.multiCohort) {
      
      const metricValues = this.customData.metric[0].metric_value;
      
      // Extract unique cohorts from colChild in the data array
      const cohortSet = new Set<string>();
      
      // Parse through all metric values to find unique cohorts
      metricValues.forEach((mv: any) => {
        if (mv.data && mv.data.length > 0) {
          mv.data.forEach((dataItem: any) => {
            if (dataItem.colChild) {
              // Extract cohort name from colChild (e.g., "Audience|Gender|Male" -> "Male")
              const parts = dataItem.colChild.split('|');
              if (parts.length > 0) {
                const cohortName = parts[parts.length - 1];
                cohortSet.add(cohortName);
              }
            }
          });
        }
      });
      
      const uniqueCohorts = Array.from(cohortSet);
      
      // If we have multiple cohorts, enable multi-cohort mode
      if (uniqueCohorts.length > 1) {
        this.isMultiCohort = true;
        
        // Create cohort data structure
        this.cohorts = uniqueCohorts.map(cohortName => {
          return {
            title: cohortName,
            metric_value: metricValues.map((mv: any) => {
              return {
                ...mv,
                data: mv.data.filter((d: any) => {
                  const parts = d.colChild ? d.colChild.split('|') : [];
                  const itemCohort = parts[parts.length - 1];
                  return itemCohort === cohortName;
                })
              };
            }).filter((mv: any) => mv.data.length > 0) // Only include metric_values that have data for this cohort
          };
        });
        
      } else {
      }
    }
  }

  updateSig() {
    this.updateSigSub?.unsubscribe();
    this.updateSigSub = this.http.get<any>('assets/Data/piechart.json').subscribe((data) => {
        if (!this.isMultiCohort) {
          this.customData.metric_value.sort((a: any, b: any) => a.selectorder - b.selectorder);
        }
        this.jsondata = data[0];
        this.chartproperties = this.jsondata['properties'][0];
        this.chartproperties = this.configuredProperties != undefined ? this.configuredProperties : this.chartproperties;
        this.seriescolor = this.piechartservice.color;
        this.seriesgradientcolor = this.piechartservice.linearGradients1;
        this.samplesizeconstant = this.piechartservice.samplesizeconstant;
         this.chartproperties.datalabelStyle = this.significanceValue == "None" ? "datalabel" : "sigChange";
        this.chartproperties.dataLabelPosition = 'right';
         this.chartproperties.datalabelStyle = this._configService.isIndexSelected ? "index" : this.chartproperties.datalabelStyle;
      //   if (this.hasCustomMetricSignificance) {
      //   this.chartproperties.datalabelStyle = "default";
      // } else {
      //   this.chartproperties.datalabelStyle =
      //     this.significanceValue == "None"
      //       ? "default"
      //       : "sigChange";
      // }

      
      // if (
      //   this._configService.isIndexSelected &&
      //   !this.hasCustomMetricIndex
      // ) {
      //   this.chartproperties.datalabelStyle = "index";
      // }
        this.Sig_LowerLimt = this.significanceService.getSigLowerLimit(this.DefaultConfidenceLevel, true);
        this.Sig_UpperLimt = this.significanceService.getSigUpperLimit(this.DefaultConfidenceLevel, true);
        
        if (this.isMultiCohort) {
          // Build color mapping by metric option so chart slices and shared legend stay in sync.
          // Do NOT key off colChild (cohort path) — that pollutes the map and offsets palette indices.
          this.globalColorMapping.clear();
          let colorIndex = 0;
          const isgradient = this.chartproperties.gradientBarColor;
          const allMetricValues = (this.customData?.metric?.[0]?.metric_value
            || this.customData?.metric_value
            || [])
            .filter((mv: any) => !mv.isInnerCircle)
            .slice()
            .sort((a: any, b: any) => (a.selectorder ?? 0) - (b.selectorder ?? 0));

          allMetricValues.forEach((mv: any) => {
            const seriesName = mv.option;
            if (seriesName && !this.globalColorMapping.has(seriesName)) {
              // Prefer widget-assigned data color so Legend button dots match chart slices
              const dataColor = (mv.data || []).find((d: any) => !!d?.color)?.color;
              const color = dataColor
                || (!isgradient ? this.seriescolor[colorIndex] : this.seriesgradientcolor[colorIndex]);
              this.globalColorMapping.set(seriesName, color);
              colorIndex++;
            }
          });

          // Fallback: ensure any cohort-level options not in the root list are also mapped
          this.cohorts.forEach((cohort) => {
            (cohort.metric_value || []).forEach((mv: any) => {
              if (mv.isInnerCircle) return;
              const seriesName = mv.option;
              if (seriesName && !this.globalColorMapping.has(seriesName)) {
                const dataColor = (mv.data || []).find((d: any) => !!d?.color)?.color;
                const color = dataColor
                  || (!isgradient ? this.seriescolor[colorIndex] : this.seriesgradientcolor[colorIndex]);
                this.globalColorMapping.set(seriesName, color);
                colorIndex++;
              }
            });
          });
          
          
          // Then render multiple charts for each cohort
          this.cohorts.forEach((cohort, index) => {
            this.plotChart(
              'chart-container' + this.id + '-' + index,
              this.jsondata['data'],
              this.chartproperties,
              cohort
            );
          });
          
          // Create shared legend after all charts are rendered
          setTimeout(() => this.createSharedLegend(), 800);
        } else {
          this.plotChart(
            'chart-container' + this.id,
            this.jsondata['data'],
            this.chartproperties
          );
        }
      });
  }
  
  createSharedLegend(): void {
    if (!this.isMultiCohort) {
      return;
    }
    
    const legendContainer = document.getElementById('shared-legend-container');
    if (!legendContainer) {
      console.warn('Legend container not found');
      return;
    }
    
    // Collect all unique series from all cohorts with their colors
    const allSeriesData: any[] = [];
    const seriesMap = new Map<string, any>();
    
    // Prefer root metric_value order (selectorder), then fall back to cohort options.
    // Colors must come from globalColorMapping keyed by metric option (same as chart slices).
    const rootMetrics = (this.customData?.metric?.[0]?.metric_value
      || this.customData?.metric_value
      || [])
      .filter((mv: any) => !mv.isInnerCircle)
      .slice()
      .sort((a: any, b: any) => (a.selectorder ?? 0) - (b.selectorder ?? 0));

    const addLegendSeries = (seriesName: string) => {
      if (!seriesName || seriesMap.has(seriesName)) return;
      const mappedColor = this.globalColorMapping?.has(seriesName)
        ? this.globalColorMapping.get(seriesName)
        : this.seriescolor[seriesMap.size];
      seriesMap.set(seriesName, {
        name: seriesName,
        y: 0,
        color: mappedColor,
        legendkeycolor: mappedColor
      });
    };

    rootMetrics.forEach((mv: any) => addLegendSeries(mv.option));
    this.cohorts.forEach((cohort: any) => {
      (cohort.metric_value || [])
        .filter((mv: any) => !mv.isInnerCircle)
        .forEach((mv: any) => addLegendSeries(mv.option));
    });
    
    allSeriesData.push(...Array.from(seriesMap.values()));
    
    // Create a hidden chart just for the legend
    const chartproperties = this.chartproperties;
    const popUpState = this.popUp;
    let legendContainerWidth = legendContainer.offsetWidth || legendContainer.clientWidth || 0;
    // If the container is hidden or very small (e.g., measured 17px when offscreen), fall back to parent or window width
    if (!legendContainerWidth || legendContainerWidth < 100) {
      const parent = legendContainer.parentElement;
      if (parent && parent.clientWidth && parent.clientWidth > 100) {
        legendContainerWidth = parent.clientWidth;
      } else if (typeof window !== 'undefined' && window.innerWidth) {
        legendContainerWidth = Math.floor(window.innerWidth * 0.9);
      } else {
        legendContainerWidth = 1000;
      }
    }

    // For popup view, use same wide legend sizing as stack chart service (full visible legend)
    const popupLegendWidth = legendContainerWidth;
    // Use full width for legend items to avoid truncation
    const popupItemWidth = Math.max(150, Math.floor((legendContainerWidth - 20) / 2));

    // Compute rows so we can give the legend chart enough height and avoid Highcharts paging (1/2 arrows)
    const legendEffectiveWidth = popUpState ? popupLegendWidth : Math.floor(legendContainerWidth);
    const itemsPerRow = Math.max(1, Math.floor(legendEffectiveWidth / popupItemWidth));
    const legendRows = Math.max(1, Math.ceil(allSeriesData.length / itemsPerRow));
    const legendChartHeight = Math.max(100, Math.min(500, legendRows * 32));

    this.sharedLegendChart = Highcharts.chart(legendContainer, {
      chart: {
        type: 'pie',
        height: legendChartHeight,
        backgroundColor: 'transparent',
        margin: [0, 0, 0, 0],
        spacing: [0, 0, 0, 0]
      },
      title: { text: '' },
      credits: { enabled: false },
      tooltip: { enabled: false },
      plotOptions: {
        pie: {
          dataLabels: { enabled: false },
          showInLegend: true,
          states: {
            hover: { enabled: false },
            inactive: { enabled: false }
          }
        }
      },
      legend: {
        enabled: true,
        layout: 'horizontal',
        align: 'center',
        verticalAlign: 'bottom',
        // Use larger widths in popup to display full legend (match stack chart behaviour)
        width: popUpState ? popupLegendWidth : undefined,
        itemWidth: popupItemWidth,
        maxHeight: legendChartHeight,
        navigation: {
          enabled: false
        },
        symbolWidth: 0,
        symbolHeight: 0,
        useHTML: true,
        itemMarginTop: 0,
        itemMarginBottom: 0,
        itemStyle: {
          fontWeight: "normal",
          fontSize: '0.8em',
          cursor: 'default',
          whiteSpace: 'normal',
          overflow: 'visible'
        },
        labelFormatter: function (): any {
          let point = this as any;
          let textcolor = chartproperties?.darkTheme ? 'white' : 'black';
          let label = point.name;
          // Prefer explicit legendkeycolor set on data items (also check options for Highcharts)
          const dotColor = point.legendkeycolor || point.options?.legendkeycolor || point.color || '#ccc';
          // Calculate text max width based on legend item width to show full text
          const itemWidthPx = popupItemWidth;
          const dotWidthPx = 10;
          const gapPx = 6;
          const textMaxPx = Math.max(0, itemWidthPx - dotWidthPx - gapPx - 4);
          return '<div style="display:flex;align-items:flex-start;font-size:0.8em;margin-bottom:4px;white-space:normal;width:' + itemWidthPx + 'px;box-sizing:border-box;overflow:hidden;" title="' + point.name + '">'
            + '<div style="flex:0 0 ' + dotWidthPx + 'px;width:' + dotWidthPx + 'px;height:' + dotWidthPx + 'px;background-color:' + dotColor + ';border-radius:50%;margin-top:2px;flex-shrink:0;"></div>'
            + '<div style="flex:1 1 auto;max-width:' + textMaxPx + 'px;font-size:0.8em;margin-left:' + gapPx + 'px;color:' + textcolor + ';line-height:1.3;word-wrap:break-word;overflow-wrap:break-word;">' + label + '</div>'
            + '</div>';
        }
      },
      series: [{
        type: 'pie',
        name: 'Legend',
        data: allSeriesData,
        size: 0, // Hide the actual pie chart
        innerSize: 0,
        visible: false
      }]
    } as any);
  }

  customization(): Observable<any> {
    // return this.piechartservice.PieChart1to10customizationList();
    const snapshotTypeSelectedName = this._customSnapshotService.selectedSnapshotType?.name;
    const cohortType = snapshotTypeSelectedName && snapshotTypeSelectedName.toLowerCase().includes('audience') 
      ? this._configService.audienceCohortType 
      : 'NA';
    return _.cloneDeep(this._customSnapshotService.getChartCustomization("01/Pie Chart", snapshotTypeSelectedName, cohortType));
  }

  seriesdata: any;
  cov: any;
  significance: any;
  significance2: any;
  samplesize: any;
  label: any;
  datalength: number = 0;


  preparemainChartData(data: any) {
    this.chartMainData = [];
    // this.chartproperties=this.configuredProperties!=undefined?this.configuredProperties:this.chartproperties;

    if (!data?.metric_value) return; 
    if (this._configService.selectedSnapshotType.toLowerCase().includes('multi')) {

      data.metric_value.forEach((lev2: any) => {
           const hasPercentageExtension =
        lev2.extensionOptions?.some(
          (e: any) =>
            e.id === 'percentageSymbol' &&
            e.selected
        ) || false;
        lev2.data.forEach((dataArr: any) => {
          let d1 = {
            // Multi-cohort pies slice by metric option; keep Series Name aligned with legend keys
            "Series Name": this.isMultiCohort
              ? lev2.option
              : (dataArr.colChild?.split("|").length > 1 ? dataArr.colChild.split("|")[1] : dataArr.colChild),
            "Category Name": lev2.metric_group,
            "Rounded Value": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
            "Value": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
            "ValueForIndex": (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
            "ActualIndexValue": (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == null) ? null : (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
            "Label": (!dataArr.data) ? "NA" : (dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data)),
            "Change value vs PY": dataArr.changeVsPY,
            "Significance": "-1",
            "Sample size": dataArr.baseValueforLSorIs,
            "Significance2": "1",
            "isPercentage": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" || dataArr.CalculationType?.toLowerCase() == "meanpercentage" ? true : false,
            "Sig_LowerLimt": this.Sig_LowerLimt,
            "Sig_UpperLimt": this.Sig_UpperLimt,
            "Significance_Value": dataArr.Significance_Value,
            "color": dataArr.color,
            "colorLinearGradient": dataArr.colorLinearGradient
          }
          this.chartMainData.push(d1);
        })
      })
    }
    else {
      let i = 0;
      data.metric_value.filter((lev2: any) => !lev2.isInnerCircle).forEach((lev2: any) => {
        lev2.data.forEach((dataArr: any) => {
          let d1 = {
            "Series Name": (() => {
              // Multi-cohort: always use metric option so colors match the shared legend
              if (this.isMultiCohort) {
                return lev2.option;
              }
              if (dataArr.rowChild) {
                const parts = dataArr.rowChild.split('|').map((p: string) => p.trim());
                return parts[parts.length - 1];
              }
              return lev2.option;
            })(),
            "Category Name": lev2.metric_group||dataArr.colChild,
            "Rounded Value": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
            "Value": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
            "ValueForIndex": (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
            "ActualIndexValue": (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == null) ? null : (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
            "Label":(!dataArr.data) ? "NA" : ((dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp") ? (dataArr.data * 100):((dataArr.CalculationType?.toLowerCase() === "index" && dataArr.data === "NA") ? "NA" : dataArr.data)),   // dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
            "Change value vs PY": dataArr.changeVsPY,
            "Significance": "-1",
            "Sample size": dataArr.baseValueforLSorIs,
            "Significance2": "1",
            "isPercentage": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" || dataArr.CalculationType?.toLowerCase() == "meanpercentage" ? true : false,
            "Sig_LowerLimt": this.Sig_LowerLimt,
            "Sig_UpperLimt": this.Sig_UpperLimt,
            "Significance_Value": dataArr.Significance_Value,
            "color": dataArr.color,
            "colorLinearGradient": dataArr.colorLinearGradient
          }
          this.chartMainData.push(d1);
        });
      });
    }

  }


  preparechartdata(data: any, islowsample: any, isgradient: any) {
    if (this.isOutput) {
      let seriesdata: any[] = [];
      let cov: any = [];
      let significance: any = [];
      let samplesize: any = [];
      let label: any = [];
      let i = 0;
      let innerSize = 40;
      let size = 35;
      let d: any = {};
      d.animation = this.piechartservice.allowAnimation;
      d.data = [];
      data.forEach((dat: any) => {

        cov.push(dat['Change value vs PY']);
        significance.push(dat['Significance']);
        label.push(dat['Label']);
        samplesize.push(dat['Sample size'])
        let value = isNaN(parseFloat(dat['Value'])) || parseFloat(dat['Value']) == null ? null : parseFloat(Number(dat['Value']).toFixed(this.chartproperties.decimalRoundOff));
        let finalvalue = !islowsample ? value : (parseFloat(dat['Sample size']) > this.samplesizeconstant ? value : 0)
        
        if (finalvalue !== null && finalvalue < 0) { return; }
        // For multi-cohort, ensure consistent colors across cohorts
        const seriesName = dat['Series Name'];
        let assignedColor: string;
        
        if (this.isMultiCohort) {
          // Prefer payload color (same source as Legend button), else shared option mapping
          if (dat['color'] && !isgradient) {
            assignedColor = dat['color'];
            this.globalColorMapping.set(seriesName, assignedColor);
          } else if (this.globalColorMapping.has(seriesName)) {
            assignedColor = this.globalColorMapping.get(seriesName)!;
          } else {
            const colorIndex = this.globalColorMapping.size;
            assignedColor = !isgradient ? this.seriescolor[colorIndex] : this.seriesgradientcolor[colorIndex];
            this.globalColorMapping.set(seriesName, assignedColor);
          }
        } else {
          // Single cohort mode - use existing logic
          assignedColor = dat['color'] ? dat['color'] : (!isgradient ? this.seriescolor[i++] : this.seriesgradientcolor[i++]);
        }
        
        let m = {
          name: dat['Series Name'],
          y: (Number(dat['Sample size']) <= this._configService.ISthreshold ? 0 : (finalvalue == null ? 0 : finalvalue)),
          indexValue: (Number(dat['Sample size']) <= this._configService.ISthreshold ? 0 : (dat['ValueForIndex'] == null ? 0 : dat['ValueForIndex'])),
          actualIndexValue: dat['ActualIndexValue'],
          y1: this._configService.isIndexSelected ? finalvalue : (Number(dat['Sample size']) <= this._configService.ISthreshold ? 0 : (finalvalue == null ? 0 : finalvalue)),
          
          legendkeycolor: assignedColor,
          actualcolor: assignedColor,
          color: assignedColor,

          cov: dat['Change value vs PY'],
          significance: dat['Significance'],
          significance2: dat['Significance2'],
          samplesize: dat['Sample size'],
          tooltip: "",
          isPercentage: dat["isPercentage"],
          Sig_LowerLimt: this.Sig_LowerLimt,
          Sig_UpperLimt: this.Sig_UpperLimt,
          Significance_Value: dat["Significance_Value"]
        }
        
        // Increment i only for non-multi-cohort mode
        if (!this.isMultiCohort && !dat['color']) {
          i++;
        }
        
        d.data.push(m);
        this.datalength++;
      });
      seriesdata = [d];
      d = {};
      this.cov = cov;
      this.significance = significance;
      this.label = label;
      this.samplesize = samplesize;
      this.seriesdata = seriesdata;
      if (this.innerCircleName) {
        this.seriesdata.unshift({
          name: this.innerCircleName,
          type: 'pie',
          data: [{
            name: this.innerCircleName,
            y: 0.0001,
            color: 'transparent',
            dataLabels: { enabled: false }
          }],
          showInLegend: true,
          color: 'transparent',
          enableMouseTracking: false,
          dataLabels: { enabled: false }
        });
      }

    }
    else {
      let seriesdata: any[] = [];
      let d: any = {};
      let cov: any = [];
      let significance: any = [];
      let significance2: any = [];
      let samplesize: any = [];
      let label: any = [];
      let i = 0;
      d.animation = this.piechartservice.allowAnimation;
      d.data = [];
      data.forEach((dat: any) => {
        cov.push(dat['Change value vs PY']);
        significance.push(dat['Significance']);
        significance2.push(dat['Significance2']);
        label.push(dat['Label']);
        samplesize.push(dat['Sample size'])
        d.name = dat['Category Name'];
        let value = isNaN(parseFloat(dat['Rounded Value'])) || parseFloat(dat['Rounded Value']) == null ? null : Number(parseFloat(dat['Value']).toFixed(this.chartproperties.decimalRoundOff))
        let finalvalue = !islowsample ? value : (parseFloat(dat['Sample size']) > this.samplesizeconstant ? value : 0)
        let m = {
          name: dat['Series Name'],
          y: finalvalue == null ? 0 : finalvalue,
          y1: finalvalue,
          actualcolor: this.seriescolor[i],
          color: !isgradient ? this.seriescolor[i++] : this.seriesgradientcolor[i++],
          cov: dat['Change value vs PY'],
          significance: dat['Significance'],
          significance2: dat['Significance2'],
          samplesize: dat['Sample size'],
          tooltip: ""
        };
        d.data.push(m);
        this.datalength++;
      });
      seriesdata = [d];
      d = {};
      this.cov = cov;
      this.significance = significance;
      this.significance2 = significance2;
      this.label = label;
      this.samplesize = samplesize
      this.seriesdata = seriesdata;
    }
  }

  private getResponsiveChartProps(): {
  center: [string, string | number],
  size: string,
  innerSize: string,
  fontSize: string,
  labelDistance: number,
  connectorWidth: number
} {
  const containerElement = document.getElementById('chart-container' + this.id);
  const insightsOpen = this.insightsOpen;

  // Multi-cohort popup uses a shared legend below the charts — fill the plot area
  if (this.popUp && this.isMultiCohort) {
    return {
      center: ['50%', '52%'],
      size: '95%',
      innerSize: '45%',
      fontSize: '0.8rem',
      labelDistance: -18,
      connectorWidth: 1
    };
  }

  // If popup is true, use fixed properties
  if (this.popUp && !this.chartproperties?.showLegend) {
    return {
      center: ['50%', '50%'],
      size: '90%',
      innerSize: '40%',
      fontSize: '0.9rem',
      labelDistance: -20,
      connectorWidth: 2
    };
  }

  if (!containerElement) {
    return { 
      center: ['50%', insightsOpen ? '50%' : '40%'], 
      size: '75%', 
      innerSize: '45%',
      fontSize: '0.8rem',
      labelDistance: -20,
      connectorWidth: 1
    };
  }

  const containerWidth = containerElement.offsetWidth;
  const containerHeight = containerElement.offsetHeight;
  //removed these line because it was causing issues with the chart sizing when the container was not square. Using only width for responsive sizing.
  //const minDimension = Math.min(containerWidth, containerHeight);
const minDimension = containerWidth;
  // If there is no legend, center the chart in the container regardless of the
  // configured legendPosition (which would otherwise offset the pie to one side).
  if (!this.chartproperties?.showLegend) {
    let size = '75%';
    let innerSize = '42%';
    let fontSize = '0.8rem';
    let labelDistance = -22;
    let connectorWidth = 1;
    if (minDimension < 400) {
      size = '70%';
      innerSize = this.popUp ? '40%' : '35%';
      fontSize = '0.7rem';
      labelDistance = -20;
    } else if (minDimension >= 800) {
      size = '65%';
      innerSize = insightsOpen ? '48%' : '45%';
      fontSize = '0.9rem';
      labelDistance = -25;
      connectorWidth = 2;
    }
    return {
      center: ['50%', insightsOpen ? '50%' : '45%'],
      size,
      innerSize,
      fontSize,
      labelDistance,
      connectorWidth
    };
  }

  // Helper to compute vertical center based on legend and insights
  const computeY = (baseYBottom: string, baseYSide: string): string => {
    if (insightsOpen) return '50%';
    return this.chartproperties?.legendPosition === 'bottom' ? baseYBottom : baseYSide;
  };

  // 📱 Mobile/Small screens (< 400px)
  if (minDimension < 260) {
    return {
      center: [
         (this.chartproperties?.legendPosition === 'left' ? '75%' : (this.chartproperties?.legendPosition === 'right' ? '23%' : this.chartproperties?.legendPosition === 'bottom' ? (this.popUp ? '50%' : '50%') : '50%')),
        (this.chartproperties?.legendPosition === 'bottom' ? (this.popUp ? '43%' : '20%') : '35%')
      ],
      size: this.chartproperties?.showLegend ? (!this.popUp ? (this.chartproperties?.legendPosition === 'bottom' ? '50%' : '65%') : '65%') : '70%',
      innerSize: this.popUp ? '90%' : '35%',
      fontSize: '0.7rem',
      labelDistance: -20,
      connectorWidth: 1
    };
  }
   if (minDimension < 400) {
    return {
      center: [
       (this.chartproperties?.legendPosition === 'left' ? '75%' : (this.chartproperties?.legendPosition === 'right' ? this.popUp?'35%':'25%' : this.chartproperties?.legendPosition === 'bottom' ? (this.popUp ? '50%' : '50%') : '50%')),
         (this.chartproperties?.legendPosition === 'bottom' ? (this.popUp ? '43%' : '20%') : this.popUp?'50%':'35%')
      ],
      size: this.chartproperties?.showLegend ? (!this.popUp ? (this.chartproperties?.legendPosition === 'bottom' ? '50%' : '65%') : '75%') : '70%',
      innerSize: this.popUp ? '40%' : '35%',
      fontSize: '0.7rem',
      labelDistance: -20,
      connectorWidth: 1
    };
  }
   if (minDimension < 500) {
    return {
      center: [
         (this.chartproperties?.legendPosition === 'left' ? (this.popUp ? '65%' : '50%') : (this.chartproperties?.legendPosition === 'right' ? (this.popUp ? '35%' : '45%') : '50%')),
          (this.chartproperties?.legendPosition === 'bottom' ? (this.popUp ? '45%' : '45%') : '50%')
      ],
      size: this.popUp ? '80%' : (this.chartproperties?.showLegend ? (this.chartproperties?.legendPosition === 'bottom' ? '60%' : '70%') : '75%'),
      innerSize: '42%',
      fontSize: '0.8rem',
      labelDistance: -22,
      connectorWidth: 1
    };
  }
  // 📱 Tablet/Medium screens (400-800px)
  if (minDimension < 800) {
    return {
      center: [
        (this.chartproperties?.legendPosition === 'left' ? (this.popUp ? '65%' : '50%') : (this.chartproperties?.legendPosition === 'right' ? (this.popUp ? '35%' : '50%') : '50%')),
        (this.chartproperties?.legendPosition === 'bottom' ? (this.popUp ? '40%' : '25%') : '40%')
      ],
      size: this.popUp ? '80%' : (this.chartproperties?.showLegend ? (this.chartproperties?.legendPosition === 'bottom' ? '66%' : '70%') : '75%'),
      innerSize: '42%',
      fontSize: '0.8rem',
      labelDistance: -22,
      connectorWidth: 1
    };
  }

  // 🖥️ Desktop/Large screens (800px+)
  return {
    center: [
      (this.chartproperties?.legendPosition === 'left' ? (this.popUp && this.chartproperties?.showLegend ? '68%' : '60%') : (this.chartproperties?.legendPosition === 'right' ? (this.popUp && this.chartproperties?.showLegend ? '30%' : '35%') : '50%')),
      (this.chartproperties?.legendPosition === 'bottom' ? (this.popUp ? '50%' : '48%') : '40%')
    ],
    size: this.chartproperties?.showLegend
      ? (this.popUp
        ? (insightsOpen ? '45%' : '42%')
        : (this.chartproperties?.legendPosition === 'bottom'
          ? (insightsOpen ? '52%' : '53%')
          : (insightsOpen ? '60%' : '55%')))
      : '65%',
    innerSize: insightsOpen ? '48%' : '45%',
    fontSize: '0.9rem',
    labelDistance: -25,
    connectorWidth: 2
  };
}
  private getLegendXPosition(chartproperties: any, popUp: boolean): number {
  const containerElement = document.getElementById('chart-container' + this.id);
  let minDimension = 800; // default for desktop
  if (containerElement) {
    const containerWidth = containerElement.offsetWidth;
    const containerHeight = containerElement.offsetHeight;
    minDimension = Math.min(containerWidth, containerHeight);
  }

  // Responsive logic based on minDimension
  if (popUp) {
    if (minDimension < 400) {
      if (chartproperties.legendPosition === 'right') return 0;
      if (chartproperties.legendPosition === 'left') return 5;
      return 0;
    }
    if (minDimension < 500) {
      if (chartproperties.legendPosition === 'right') return 5;
      if (chartproperties.legendPosition === 'left') return 40;
      return 0;
    }
    if (chartproperties.legendPosition === 'right') return 10;
    if (chartproperties.legendPosition === 'left') return 15;
    return 0;
  } else {
    if (minDimension < 220) {
           if (chartproperties.legendPosition === 'right') return 110;
      if (chartproperties.legendPosition === 'left') return 120;
      return 10;
  
    }
     if (minDimension < 240) {
           if (chartproperties.legendPosition === 'right') return 90;
      if (chartproperties.legendPosition === 'left') return -10;
      return 10;
  
    }
     if (minDimension < 280) {
           if (chartproperties.legendPosition === 'right') return 30;
      if (chartproperties.legendPosition === 'left') return -10;
      return 10;
  
    }
    
    if (minDimension < 400) {
     if (chartproperties.legendPosition === 'right') return 60;
      if (chartproperties.legendPosition === 'left') return 120;
      return 10;
    }
    if (minDimension < 500) {
      if (chartproperties.legendPosition === 'right') return 80;
      if (chartproperties.legendPosition === 'left') return -10;
      return 15;
    }
    if (minDimension < 800) {
      if (chartproperties.legendPosition === 'right') return 20;
      if (chartproperties.legendPosition === 'left') return 150;
      return 20;
    }
    // Desktop/Large screens
    if (chartproperties.legendPosition === 'right') return 120;
    if (chartproperties.legendPosition === 'left') return -10;
    return 20;
  }
}
  private getLegendItemWidth(chartproperties: any, popUp: boolean): number {
  const containerElement = document.getElementById('chart-container' + this.id);
  let minDimension = 800; // default for desktop
  if (containerElement) {
    const containerWidth = containerElement.offsetWidth;
    const containerHeight = containerElement.offsetHeight;
    minDimension = Math.min(containerWidth, containerHeight);
  }

  // Responsive logic based on minDimension
  if (popUp) {
    if (minDimension < 400) {
      return 380;
    }
    if (minDimension < 500) {
      return 520;
    }
    return 620;
  } else {
    if (minDimension < 400) {
      if (chartproperties.legendPosition === 'bottom') return 120;
      if (chartproperties.legendPosition === 'left') return 200;
      return 250;
    }
    if (minDimension < 500) {
      if (chartproperties.legendPosition === 'bottom') return 160;
      if (chartproperties.legendPosition === 'left') return 180;
      return 100;
    }
    if (minDimension < 800) {
      if (chartproperties.legendPosition === 'bottom') return 200;
      if (chartproperties.legendPosition === 'left') return 220;
      return 400;
    }
    // Desktop/Large screens
    if (chartproperties.legendPosition === 'bottom') return 200;
    if (chartproperties.legendPosition === 'left') return 220;
    return 250;
  }
}

  chart: any;
  plotChart(containerId: any, jsondata: any, chartproperties: any, cohortData?: any) {
      const popUpState = this.popUp;
      const componentId = this.id; // Capture component id for use in nested functions

      const componentRef = this; // Capture component reference for insights state
      const getLegendItemWidth = this.getLegendItemWidth.bind(this);
      const isMultiCohort = this.isMultiCohort; // Capture multi-cohort state
      
    if (this.isOutput) {
      localStorage.setItem("properties", JSON.stringify(this.chartproperties));
      let height = this.height;
    
      let samplesizeconstant = this.samplesizeconstant;
      let chartimagepath = this.chartimagepath;
      
      // Use cohortData if provided (multi-cohort mode), otherwise use customData
      const dataToUse = cohortData ? cohortData : this.customData;
      const innerMetricObj = this.innerMetricObj ?? null;
      let innerData = innerMetricObj?.metric_value?.[0]?.data?.[0];
      if (!innerData && this.innerAudienceObj) {
        innerData = this.innerAudienceObj?.data?.[0];
      }
      const rawVal = innerData?.data;
      const covVal = innerData?.changeVsPY_Total ?? innerData?.changeVsPY_Answer;
      const sigVal = innerData?.Significance_Value;
      const self = this;
      const indexVal = innerData?.data2;
      const calculationType = innerData?.CalculationType?.toLowerCase();
      const isMean = calculationType === 'mean';
      const isPercentage = calculationType === 'share' || calculationType === 'respgrp';
      if (this._configService.isIndexSelected && indexVal != null && indexVal !== -9999) {
        const percentVal = rawVal != null && Number(rawVal) !== 0? isMean
        ? Number(rawVal).toFixed(this.chartproperties?.decimalRoundOff ?? 2)
        : (rawVal * 100).toFixed(this.chartproperties?.decimalRoundOff ?? 2) + '%' : null;
        const idxNum = parseFloat(Number(indexVal).toFixed(1));
        const idxColor = idxNum > 120 ? 'green' : idxNum < 80 ? 'red' : 'black';
        this.innerCircleDisplayValue = percentVal;
        this.innerCircleSigText = `(${idxNum})`;
        this.innerCircleSigColor = idxColor;
      } 
      else {
        this.innerCircleDisplayValue = rawVal != null && Number(rawVal) !== 0? isMean ? Number(rawVal).toFixed(this.chartproperties?.decimalRoundOff ?? 2) : (rawVal * 100).toFixed(this.chartproperties?.decimalRoundOff ?? 2) + '%' : null;
      if (chartproperties.datalabelStyle === 'sigChange' && covVal != null) {
        const isPercentage = innerData?.CalculationType?.toLowerCase() === 'share';
        const changeVal = isPercentage ? (Number(covVal) * 100) : Number(covVal);
        const sigClass = (sigVal < this.Sig_LowerLimt || changeVal < 0) ? 'red' : 'black';
        this.innerCircleSigText = `(${parseFloat(changeVal.toFixed(1))}${isPercentage ? '%' : ''})`;
        this.innerCircleSigColor = sigClass;
      } else {
        this.innerCircleSigText = null;
        this.innerCircleSigColor = 'black';
      }
    }
    this.innerCircleLabel = innerMetricObj?.metric_option ?? null;
      this.preparemainChartData(dataToUse);
      this.chartMainData = this.chartMainData.filter((item: any) => item['Label'] !== 'NA' && item['Label'] !== null);
      // Deduplicate by series name: a pie chart should have at most one slice per series name.
      // When custom metric + significance value are active, the data can return multiple entries
      // per metric value (e.g. current + comparison period), causing duplicate legend items.
      const _seenSeriesNames = new Set<string>();
      this.chartMainData = this.chartMainData.filter((item: any) => {
        if (_seenSeriesNames.has(item['Series Name'])) return false;
        _seenSeriesNames.add(item['Series Name']);
        return true;
      });
      this.preparechartdata(this.chartMainData, chartproperties.datalabelStyle == 'ls', chartproperties.gradientBarColor);
      const configService = this._configService;

      const containerEl = document.getElementById(containerId);
      if (!containerEl) { return; }

      if (!this.seriesdata || !this.seriesdata[0]?.data?.length) {
        containerEl.innerHTML = '<div style="display:flex; align-items:center; justify-content:center; height:100%; min-height:100px; font-size: 0.7rem; font-family:KantarBrown-Regular,sans-serif;">Not Applicable</div>';
        return;
      }
      
      // Destroy any existing Highcharts chart in this container before creating a new one.
      // This prevents duplicate legends when updateSig re-renders (e.g. on significance value change).
      if (this.chart && this.chart.container === containerEl) {
        this.chart.destroy();
        this.chart = null;
      }
      
      // For multi-cohort, hide legend on individual charts
      const showLegendForChart = isMultiCohort ? false : chartproperties.showLegend;
      this.chart = Highcharts.chart(containerEl, {
        accessibility: {
          point: {
            valueSuffix: '%'
          }
        },
        chart: {
          type: 'pie',
          spacingTop: this.popUp && isMultiCohort ? 4 : undefined,
          spacingBottom: this.popUp && isMultiCohort ? 4 : (this.popUp ? (chartproperties.showLegend && chartproperties.legendPosition == "bottom" ? 10 : 0) : (chartproperties.showLegend && chartproperties.legendPosition === 'bottom' ? 8 : 0)),

          marginBottom: this.popUp && isMultiCohort ? 0 : (this.popUp ? (chartproperties.showLegend && chartproperties.legendPosition == "bottom" ? 10 : 10) : (chartproperties.showLegend && chartproperties.legendPosition === 'bottom' ? 35 : 0)), // Reserve bottom space for legend gap
          marginRight: this.popUp && isMultiCohort ? 4 : (this.popUp && chartproperties.showLegend && chartproperties.legendPosition === 'right' ? 270 : chartproperties.legendPosition == "right" ? 0 : this.popUp?10:(chartproperties.legendPosition == "left" ? 50 : 5)),
          marginLeft: this.popUp && isMultiCohort ? 4 : (this.popUp && chartproperties.showLegend && chartproperties.legendPosition === 'left' ? 270 : this.popUp?10:chartproperties.legendPosition=="left"?40:20),
          backgroundColor: chartproperties.darkTheme ? '#333' : 'white',
          style: {
            fontFamily: this.piechartservice.fontFamily,
            width: '100%',
            
            // width:300,
            // height:"100%"
          },
            events: {
              load: function (this: Highcharts.Chart) {
              const chart = this as any;
              // window.addEventListener('resize', function () {
              //   chart.reflow();
              // });
              
             const legendClass = popUpState ? 'pie11-popup' : 'pie11';

// Add class to SVG legend group (for SVG styling, if needed)
if (this.legend && this.legend.group && this.legend.group.element) {
  this.legend.group.element.classList.add(legendClass);
}

// Add class to HTML legend container (for CSS targeting)
if (this.container) {
  // Legend container
  const htmlLegend = this.container.querySelector('.highcharts-legend');
  if (htmlLegend) {
    htmlLegend.classList.add(legendClass);
  }
  // Legend items
  const legendItems = this.container.querySelectorAll('.highcharts-legend-item');
  legendItems.forEach((item: Element) => {
    item.classList.add(legendClass);
  });
  // No-tooltip overlays
  const noTooltipEls = this.container.querySelectorAll('.highcharts-no-tooltip');
  noTooltipEls.forEach((el: Element) => {
    el.classList.add(legendClass);
  });
}
            },
            render:     function (this: Highcharts.Chart) {
              
               const legendClass = popUpState ? 'pie11-popup' : 'pie11';

// Add class to SVG legend group (for SVG styling, if needed)
if (this.legend && this.legend.group && this.legend.group.element) {
  this.legend.group.element.classList.add(legendClass);
}

// Add class to HTML legend container (for CSS targeting)
if (this.container) {
  // Legend container
  const htmlLegend = this.container.querySelector('.highcharts-legend');
  if (htmlLegend) {
    htmlLegend.classList.add(legendClass);
  }
  // Legend items
  const legendItems = this.container.querySelectorAll('.highcharts-legend-item');
  legendItems.forEach((item: Element) => {
    item.classList.add(legendClass);
  });
  // No-tooltip overlays
  const noTooltipEls = this.container.querySelectorAll('.highcharts-no-tooltip');
  noTooltipEls.forEach((el: Element) => {
    el.classList.add(legendClass);
  });

}
            }

          }
        },
         
        
        title: {
          text: "",
          align: chartproperties.chartTitlePosition,
          verticalAlign: 'top',
          style: {
            color: chartproperties.darkTheme ? 'white' : 'black',
            fontSize: "2rem"
          },
        },
        legend: {
          navigation: {
            itemMarginLeft: 10,
            activeColor: '#7f7f7f',
            animation: true,
            arrowSize: 10,
            inactiveColor: '#ccc',
            enabled: true, // Explicitly enable navigation arrows
            
            style: {
              fontSize: '0.7em',
              color: chartproperties.darkTheme ? 'white' : '#333',
            },

          itemStyle: {
                color: chartproperties.darkTheme ? 'white' : 'black', // Change this to your desired color
                fontWeight: 'normal',
                fontSize: '0.8em'
            },
            verticalAlign:
        chartproperties.legendPosition != 'bottom' ? 'middle' : 'bottom',
          },
           layout:
        chartproperties.legendPosition != 'bottom'
          ? 'vertical'
          : 'horizontal',
          enabled: showLegendForChart,
          // y:chartproperties.legendPosition == 'bottom'?0:4,
          maxHeight: this.popUp ? (chartproperties.legendPosition == 'bottom' ? 120 : 300) : (chartproperties.legendPosition == 'bottom' ? 120 : 200), // Increased height for better spacing
          x: chartproperties.legendPosition == "left" ? 10 : this.getLegendXPosition(chartproperties, this.popUp),
          // x: this.popUp ? (chartproperties.legendPosition == 'right' ? 5 : (chartproperties.legendPosition == 'left' ? 80 : 0)) : chartproperties.legendPosition == 'right' ? 150 : (chartproperties.legendPosition == 'left' ? 5 : 20),
          y: (() => {
            const isOpen = componentRef.insightsOpen;
            if (this.popUp) {
              return chartproperties.legendPosition == 'bottom' ? -35 : 20;
            } else {
              if (chartproperties.legendPosition === 'left' || chartproperties.legendPosition === 'right') {
                // Center vertically when insights panel is open
                return isOpen ? 0 : -30;
              } else if (chartproperties.legendPosition === 'bottom') {
                return isOpen ? -10 : -12; // Gap between chart and legend
              }
              return 0;
            }
          })(),
    verticalAlign: chartproperties.legendPosition != 'bottom' ? 'middle' : 'bottom',
          // width: height=='100%'?100:'100%',
              itemWidth:this.getLegendItemWidth(chartproperties, this.popUp),
           // itemWidth: this.popUp?520:chartproperties.legendPosition=='bottom'?200:320, // Set legend item width (adjust as needed)
          align:  chartproperties.legendPosition,
      
          symbolWidth: 0,  // Set to a valid non-negative value
          symbolHeight: 0, // Set to a valid non-negative value
          //symbolWidth: -1,
          //symbolHeight: -1,
          useHTML: true,
          itemMarginTop: 0,    // Adjust this value to reduce the top margin
          
          itemMarginBottom:this.popUp? 5:0,
          itemStyle: {
            fontWeight: "normal",
            // fontSize: '0.8em',
            fontSize:(0.8 * ((this.popUp || this.height === '100%') ? 1.45 : 1)) + 'em',
            cursor: 'pointer'
          },
            labelFormatter: function (): any {
              let point = this as any;
              let textcolor = chartproperties.darkTheme ? 'white' : 'black';
              let label = point.name;
              
              // Different handling for popup vs non-popup mode
                       if (!popUpState) {
  // Set legend item width
  const currentItemWidth =
    chartproperties.legendPosition === 'bottom'
      ? 200
      : getLegendItemWidth(chartproperties, popUpState);

  // Constants for spacing and font estimation
  const iconWidth = 10;
  const paddingLeft = 10;
  const availableWidth = currentItemWidth - iconWidth - paddingLeft;

  const fontSize = 0.8; // in em
  const avgCharWidth = fontSize * 8; // px per character (approx)
  const charsPerLine = Math.floor(availableWidth / avgCharWidth);

  // Split label into words
  const words = label.split(' ');
  let line1 = '';
  let line2 = '';
  let currentLine = '';

  for (let i = 0; i < words.length; i++) {
    const testLine = currentLine.length > 0 ? currentLine + ' ' + words[i] : words[i];

    if (testLine.length <= charsPerLine) {
      currentLine = testLine; // word fits, keep adding
    } else {
      if (line1 === '') {
        // Move currentLine to first line and start second line
        line1 = currentLine;
        currentLine = words[i]; // start second line
      } else {
        // Exceeded second line → truncate
        line2 = currentLine;
        currentLine = words[i];
        break;
      }
    }
  }

  // Assign remaining text
  if (!line1) {
    line1 = currentLine;
  } else if (!line2) {
    line2 = currentLine;
  }

  // If still words left beyond 2 lines → truncate second line
  const remainingWords = words.join(' ').length > (line1 + line2).length;
  if (remainingWords && line2.length > charsPerLine - 3) {
    line2 = line2.slice(0, charsPerLine - 3) + '...';
  }

  // Build final label
  if (line2) {
    label = `${line1}<br>${line2}`;
  } else {
    label = line1;
  }
}else {
                // For popup mode: original logic (single line break)
                const maxLen = 300;
                if (label.length > maxLen) {
                  const idx = label.lastIndexOf(' ', maxLen);
                  if (idx > 0) {
                    label = label.slice(0, idx) + '<br>' + label.slice(idx + 1);
                  }
                }
              }
              
              if (point.color != "#eeebed" && point.color != "#7f7f7f") {
                let legendMarginBottom = (chartproperties.legendPosition === 'left' || chartproperties.legendPosition === 'right') ? 'margin-bottom:4px;' : 'margin-bottom:2px;';
                
                // Apply position relative and left offset only for bottom legend position
                let positionStyle = chartproperties.legendPosition == 'bottom' ? '' : ''; // Remove left positioning to prevent overlap
                
                // Calculate legend width based on popup state and available space
                let legendWidth;
                if (popUpState) {
                  // Use fixed width for popup mode
                  if (chartproperties.legendPosition == 'bottom') {
                    legendWidth = '12rem'; // Smaller width for bottom legends to fit side by side
                  } else {
                    legendWidth = height != "100%" ? '30rem' : '29.5rem';
                  }
                } else {
                  if (chartproperties.legendPosition == 'bottom') {
                    // For bottom position, use smaller fixed width to allow side-by-side display
                    legendWidth = '25rem';
                  } else {
                    // Calculate available width for non-popup mode
                    const containerElement = document.getElementById('chart-container' + componentId);
                    if (containerElement) {
                      const containerWidth = containerElement.offsetWidth;
                      // Get chart size from responsive props (we'll use a fallback calculation)
                      const chartSizePercentage = chartproperties?.showLegend ? 0.65 : 0.75; // Based on our earlier size logic
                      const chartWidth = containerWidth * chartSizePercentage;
                      const availableWidth = containerWidth - chartWidth - 20; // 30px buffer
                      legendWidth = Math.max(150, availableWidth) + 'px'; // Minimum 150px width
                    } else {
                      legendWidth = '200px'; // Fallback width
                    }
                  }
                }
                
                let wrapStyle = '';
                  if (popUpState) {
                    // For popup mode: show full legend without ellipsis
                    wrapStyle = `
              display: -webkit-box;
              -webkit-line-clamp: auto;
              -webkit-box-orient: vertical;
              overflow: visible;
              white-space: normal;
              word-break: break-word;
          `;
                  } else {
                    // For non-popup mode: truncate to 2 lines with ellipsis
                    wrapStyle = `
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              overflow: hidden;
              white-space: normal;
              text-overflow: ellipsis;
              word-break: break-word;
          `;
                  }
  

   return '<div style="display:flex;align-items:center;font-size:0.8em;' +legendMarginBottom + positionStyle + '" title="' + point.name + '">'
       + '<div style="display:flex;width:10px;height:10px;' + (point.name === self.innerCircleName ? 'background-color:white;border:1.5px solid #333;' : 'background-color:' + point.legendkeycolor + ';') + 'border-radius:50%"></div>'
        + '<div style="width:' + legendWidth + ';font-size:0.8em;margin-left:6px;color:' + textcolor + ';' +'padding-top:'+ (popUpState ? '1px' : '5px')+';'+ wrapStyle + 'flex:1;line-height:1.1;" title="' +  point.name + '">' + '   '+label + '</div>'
        + '</div>';
        }
            },
        },
        tooltip: {
          enabled: true,
          borderWidth: 1,
          useHTML: true,
          shape: 'square',
          shadow: false,
          backgroundColor:  'white',  
          outside: this.popUp ? false : true,
          style: {
            fontSize: '0.8rem'
          },
          formatter: function (this: any): any {
            const pointWithMetric = this.point as {
              name?: any;
              parent?: any;
              color?: any;
              actualcolor?: any;
              y?: number;
              y1?: number;
              cov?: string;
              significance?: string;
              significance2?: string;
              samplesize?: number;
              tooltip?: any;
              Significance_Value?: any;
            };
            if (pointWithMetric.color === '#eeebed' || pointWithMetric.color === '#7f7f7f') { return false };
            const backgroundcolor = chartproperties.darkTheme ? '#b3b3b3' : '#f5f5f5';
            const backgroundcolor2 = chartproperties.darkTheme ? '#dddddd' : 'white';
            if (pointWithMetric.tooltip == "") { pointWithMetric.tooltip = pointWithMetric.y1 == null ? 'NA' : pointWithMetric.y }

            let isDefaultTooltip = chartproperties.toolTipStyle;
            if (isDefaultTooltip == "style1") {
              const dotColor = pointWithMetric.actualcolor;
              this.point.series.tooltipOptions.borderColor = dotColor;
              this.point.series.tooltipOptions.borderWidth=10;
             const content =
    `<div class="high-z-tooltip" style="background: #fff;  min-width: 20px; font-size: 0.8em; display: flex; box-shadow: none;align-items: center;z-index:999 !important;padding:2px;">
      <span style=" width:10px; height:10px; border-radius:50%; background:${dotColor}; margin-right:8px; vertical-align:middle;"></span>
      <span>${pointWithMetric.name}: </span>
      <b style="margin-left:4px;">${pointWithMetric.tooltip}</b>
    </div>`;
  return content;
              return content + '</div>';
            }
            else if (chartproperties.datalabelStyle === 'sigChange') {

            }
            else {
              const dotColor = pointWithMetric.actualcolor; // Get the series color

             
                const commonContent =
                `<div style="border-left: 2px solid ` + dotColor + `;font-size:0.7em; border-bottom: 2px solid ` + dotColor + `; z-index: 100; padding: 5px; border-radius: 5px; margin: 0px; background-color :${backgroundcolor2};">` +
                // `<span style="display: block; text-align: center; color: `+dotColor+`; font-weight: bold; font-size: 12px;">Tooltip Title</span>` +
                // `<span><strong>Series Name:</strong></span>Brands<br>` +
                ` ${pointWithMetric.name} : ` +
                `${pointWithMetric.tooltip}`;
              return commonContent + '</div>';

            }



          },
        },
        plotOptions: {
          series: {
            allowPointSelect: false,
            states: {
              hover: {
                enabled: false
              },
              inactive: {
                enabled: false
              },
              select: {
                enabled: false
              }
            }
          },
          pie: {
            point: {
              events: {
                legendItemClick: function (this: any) {
                const clickedName = this.name || this.series?.name;
                if ( clickedName && self.innerCircleName && clickedName.toString().trim() === self.innerCircleName.toString().trim() ) {
                  const innerText = document.getElementById('inner-circle-' + self.id);
                  const sigText = document.getElementById('inner-circle-sig-' + self.id);
                  const isHidden = innerText?.style.visibility === 'hidden';
                  if (innerText) {
                    innerText.style.visibility = isHidden ? 'visible' : 'hidden';
                  }
                  if (sigText) {
                    sigText.style.visibility = isHidden ? 'visible' : 'hidden';
                  }
                  return false;
                }
                return true;
              }
            }
          },
           
          //  center: this.popUp?['50%','45%']:['50%', '60%'], // Center the pie chart
          //   size: this.height === '100%' ? '100%' : (this.height === '11em' ? '95%' : '90%'), // Made even wider
          //    innerSize: this.height === '100%' ? '70%' : (this.height === '11em' ? '45%' : '60%'), // Dynamic inner size
          center: this.getResponsiveChartProps().center,
    size: this.getResponsiveChartProps().size,
    innerSize: this.getResponsiveChartProps().innerSize,
            showInLegend: chartproperties.showLegend,
            borderWidth: 3, // Add gap between pie slices
            borderColor: 'white', // White gap color
            borderRadius: 0, // Remove rounded edges
            slicedOffset: 10,
            shadow: chartproperties.shadow ? {
              color: 'rgba(0, 0, 0, 0.5)',
              offsetX: 1,
              offsetY: 1,
              opacity: 0.5,
              width: 6,
            } : false,
            dataLabels: {
              allowOverlap: true,
              align: function (this: Highcharts.TooltipFormatterContextObject): string {
                // Align labels based on the position of the data point
                return (this.point.index % 2 === 0) ? 'left' : 'right';
              },
              //alignTo: 'connectors',
              //y: 0,
              style: {
                textOutline: 'none',
                fontSize: this.getResponsiveChartProps().fontSize,
                fontWeight: "normal"
              },
              color:
                chartproperties.dataLabelColor == 'default'
                  ? chartproperties.darkTheme
                    ? 'white'
                    : 'black'
                  : chartproperties.dataLabelColor,
              crop: false,
              enabled: chartproperties.showDataLabel,
              // connectorWidth: chartproperties.connector ? 1 : -1,
              // connectorColor: null,
              // //color: chartproperties.dataLabelColor == "default" ? (chartproperties.darkTheme ? 'white' : 'black') : chartproperties.dataLabelColor,
              // connectorPadding: 0,
              // distance: chartproperties.connector ? 20 : 50,
              // connectorShape: 'crookedLine',
              // crookDistance: '70%',
              // softConnector: false,
              distance: 2,
              connectorWidth: -1,
              useHtml: true,
              formatter: function (this: Highcharts.TooltipFormatterContextObject): any {
                const pointWithMetric = this.point as {
                  name?: any;
                  parent?: any;
                  color?: any;
                  y?: number;
                  y1?: number;
                  cov?: string;
                  significance?: string;
                  samplesize?: number;
                  significance2?: any;
                  tooltip?: any;
                  isPercentage?: any;
                  Sig_LowerLimt?: any;
                  Sig_UpperLimt?: any;
                  Significance_Value?: any;
                  indexValue?: any;
                  actualIndexValue?: any;
                };
                if (this.point.color !== '#eeebed' && this.color != '#7f7f7f') {

                  chartproperties.dataLabelFormat = pointWithMetric.isPercentage;
                  ;
                  let textcolor = chartproperties.dataLabelColor == 'default'
                    ? (chartproperties.darkTheme ? 'white' : 'black')
                    : chartproperties.dataLabelColor;
                  if (chartproperties.datalabelStyle == 'datalabel') {
                    ;
                    let text = pointWithMetric.y1 != null ? pointWithMetric.y + (chartproperties.dataLabelFormat ? '%' : '') : 'NA';
                    text = configService.CheckLSorIScondition(configService.userRole, text, Number(pointWithMetric.samplesize));
                    pointWithMetric.tooltip = text;
                    return (
                      '<span style="color:' + textcolor + ';font-size:'+ chartproperties.dataLabelSize +'">' + text + '</span>'
                    );
                  }
                  //new
                  if (chartproperties.datalabelStyle === "index") {

                    let text = pointWithMetric.y1 != null ? pointWithMetric.y + (chartproperties.dataLabelFormat ? '%' : '') : 'NA';
                    text = configService.CheckLSorIScondition(configService.userRole, text, Number(pointWithMetric.samplesize));

                    // let text2 = pointWithMetric.y1 == 0 ? 'NA' :pointWithMetric.y1 == -1 ? -1 : pointWithMetric.y1 != null ? pointWithMetric.indexValue.toFixed(1) : 'NA';
                    let text2 = pointWithMetric.actualIndexValue == null ? 'NA' : pointWithMetric.y1 == -1 ? -1 : pointWithMetric.y1 != null ? pointWithMetric.indexValue.toFixed(1) : 'NA';

                    if (text2 == "-1" || text2 == -1) {
                      text2 = "NA";
                    }
                    text2 = configService.CheckLSorIScondition(configService.userRole, String(text2), Number(pointWithMetric.samplesize));

                    let color = configService.CheckIndexColoring(String(text2));
                    pointWithMetric.tooltip = text + "(" + text2 + ")";
                    return (
                      '<span style="font-size:0.5rem;color:' + textcolor + ';">' + text + " " + '(' +
                      '<span style="color:' + color + ';font-size:0.45rem;">' + text2 + '</span>' + ')</span>'
                    );
                  }

                  if (chartproperties.datalabelStyle === 'sigChange') {
                    let textCheck = configService.CheckLSorIScondition(configService.userRole, String(pointWithMetric.y), Number(pointWithMetric.samplesize));
                    let changeVal = pointWithMetric.isPercentage ? (Number(pointWithMetric.cov) * 100) : (Number(pointWithMetric.cov));
                    if (pointWithMetric.cov == null || pointWithMetric.cov == 'NA') {
                      let text = textCheck + (chartproperties.dataLabelFormat ? '%' : '') + ' ' + `<span span style="font-size: 80%;color:black;">(${'NA'})</span>`;
                      pointWithMetric.tooltip = text;
                      return (
                        '<span style="color:' + textcolor + ';font-size:'+ chartproperties.dataLabelSize +'">' + text + '</span>'
                      );
                    }
                    else {
                      let sigClass = (pointWithMetric.Significance_Value < pointWithMetric.Sig_LowerLimt || Number(changeVal) < 0) ? 'red' : 'black';
                      let valueText = textCheck + ((chartproperties.dataLabelFormat && textCheck != 'I/S') ? '%' : '');
                      let changeText = (pointWithMetric.cov != null ? parseFloat(Number(changeVal).toFixed(1)) + (chartproperties.dataLabelFormat ? '%' : '') : 'NA');
                      pointWithMetric.tooltip = valueText + (textCheck != 'I/S' ? ' (' + changeText + ')' : '');
                      return (
                        '<span style="color:' + textcolor + ';font-size:'+ chartproperties.dataLabelSize +'">' + valueText + '</span>' +
                        (textCheck != 'I/S' ? '<span style="font-size: 80%; color: ' + sigClass + ';"> (' + changeText + ')</span>' : '')
                      );

                    }

                  }
                  if (chartproperties.datalabelStyle === 'change') {
                    let text = pointWithMetric.y1 != null ? pointWithMetric.y + (chartproperties.dataLabelFormat ? '%' : '') + ' ' + `<span span style="font-size: 80%;color:` + (chartproperties.darkTheme ? 'white' : 'black') + `">(` + `${pointWithMetric.cov} )</span>` : 'NA';
                    pointWithMetric.tooltip = text;
                    return (
                      '<span style="color:' + textcolor + ';font-size:'+ chartproperties.dataLabelSize +'">' + text + '</span>'
                    );
                  }
                  if (chartproperties.datalabelStyle === 'significance + changeVs') {
                    const upwardTriangle = '\u25B2';
                    const downwardTriangle = '\u25BC';
                    let sig = Number(pointWithMetric.significance);
                    let s =
                      sig > 0 ? upwardTriangle : sig < 0 ? downwardTriangle : '';
                    let sigcolor = sig > 0 ? 'green' : sig < 0 ? 'red' : '';
                    let text = pointWithMetric.y1 != null ? pointWithMetric.y + (chartproperties.dataLabelFormat ? '%' : '') + ' ' + `<span style="font-size: 80%;color:` + (chartproperties.darkTheme ? 'white' : 'black') + `">(` + `${pointWithMetric.cov} )</span>` + '<span style="color:' +
                      sigcolor +
                      ';">' +
                      s +
                      '</span>' : 'NA';
                    pointWithMetric.tooltip = text;
                    return (
                      '<span style="color:' +
                      textcolor +
                      ';font-size:'+ chartproperties.dataLabelSize +'">' +
                      text +
                      '</span>'
                    );
                  }
                  if (chartproperties.datalabelStyle == 'significance') {
                    const upwardTriangle = '\u25B2';
                    const downwardTriangle = '\u25BC';
                    let sig = pointWithMetric.significance;
                    let s =
                      Number(sig) > 0 ? upwardTriangle : Number(sig) < 0 ? downwardTriangle : '';
                    let sigcolor = Number(sig) > 0 ? 'green' : Number(sig) < 0 ? 'red' : '';
                    let text = pointWithMetric.y1 != null ? (pointWithMetric.y + (chartproperties.dataLabelFormat ? '%' : '') + '<span style="color:' + sigcolor + ';">' + s + '</span>') : 'NA';
                    pointWithMetric.tooltip = text;
                    return (
                      '<span style="color:' +
                      textcolor +
                      ';font-size:'+ chartproperties.dataLabelSize +'">' +
                      text +
                      '</span>'
                    );
                  }
                  if (chartproperties.datalabelStyle == 'ls') {
                    let text = Number(pointWithMetric.samplesize) > samplesizeconstant ? (pointWithMetric.y1 == null ? 'NA' : pointWithMetric.y + (chartproperties.dataLabelFormat ? '%' : '')) : 'LS';
                    pointWithMetric.tooltip = text;
                    return (
                      '<span style="color:' + textcolor + ';font-size:'+ chartproperties.dataLabelSize +'">' + text + '</span>'
                    );
                  }
                  if (chartproperties.datalabelStyle == "significance2") {
                    const upwardTriangle = '\u25B2';
                    const downwardTriangle = '\u25BC';
                    let text = pointWithMetric.y1 != null ? this.y + (chartproperties.dataLabelFormat ? '%' : '') : 'NA';
                    let changeText = pointWithMetric.cov;
                    let sig = pointWithMetric.significance;
                    let sig1 = pointWithMetric.significance2;
                    let sColor = Number(sig) > 0 ? 'green' : (Number(sig) < 0 ? 'red' : '');
                    let s = Number(sig) > 0 ? upwardTriangle : (Number(sig) < 0 ? downwardTriangle : '');
                    let changeColor = sig1 < 0 ? 'red' : (sig1 > 0 ? 'green' : (chartproperties.darkTheme ? 'white' : 'black'));

                    if (Number(changeText) > 0) {
                      changeText = "+" + changeText;
                    }
                    pointWithMetric.tooltip = '<span>' + text +
                      (pointWithMetric.y1 != null && changeText ? '&nbsp<span style="color:' + ';"> ' +
                        '<span style="font-size: 80%; color:' + changeColor + ';">(' + changeText + ')</span> &nbsp' +
                        '<span style="color:' + sColor + ';">' + s + '</span>' : '') +
                      '</span>';
                    return (
                      '<span>' + text +
                      (pointWithMetric.y1 != null && changeText ? '&nbsp<span style="color:' + ';"> ' +
                        '<span style="font-size: 80%; color:' + changeColor + ';">(' + changeText + ')</span> &nbsp' +
                        '<span style="color:' + sColor + ';">' + s + '</span>' : '') +
                      '</span>'
                    );
                  }
                } else {
                  return null;
                }
              },
            }

          }
        },
        series: this.seriesdata,
        credits: {
          enabled: false
        },
        exporting: {
          enabled: false
        }
      } as any,
      );
      if (this.innerCircleDisplayValue) {
        setTimeout(() => {
          const chart = this.chart as any;
          const centerX = chart.series[0].center[0] + chart.plotLeft;
          const centerY = chart.series[0].center[1] + chart.plotTop;
          const existing = document.getElementById('inner-circle-' + this.id);
          const baseSize = parseFloat(chartproperties.dataLabelSize || '0.7');
          const centerLabelSize = (baseSize * 0.74) + 'em';
          const sigLabelSize = (baseSize * 0.68) + 'em';
          if (existing) existing.remove();
          document.querySelectorAll('.inner-circle-tooltip-' + this.id).forEach(el => el.remove());
          const tooltipEl = document.createElement('div');
          tooltipEl.className = 'inner-circle-tooltip-' + this.id;
          tooltipEl.innerHTML = `
            <div style="background:white;color:#333;padding:8px 12px;border-radius:4px;
              font-size:0.60rem;pointer-events:none;display:none;z-index:9999;
              white-space:nowrap;box-shadow:0 2px 8px rgba(0,0,0,0.15);border:1px solid #000;"
              class="inner-tooltip-content">
              <div style="display:flex;align-items:center;gap:8px;">
                <div style="width:10px;height:10px;border-radius:50%;background:white;border:1px solid #000;flex-shrink:0;"></div>
                <span>${this.innerCircleName}:</span>
                <span style="font-weight:bold;">${this.innerCircleDisplayValue}${this.innerCircleSigText ? '<br><span style="color:' + this.innerCircleSigColor + ';font-weight:normal;">' + this.innerCircleSigText + '</span>' : ''}</span>
              </div>
            </div>`;
          document.body.appendChild(tooltipEl);
          chart.renderer.text(
            this.innerCircleDisplayValue,
            centerX,
            this.innerCircleSigText ? centerY - 6 : centerY
          )
          .attr({id: 'inner-circle-' + this.id, align: 'center', zIndex: 5 })
          .css({
            fontSize: centerLabelSize, // ✅ label size
            fontWeight: 'normal',
            cursor: 'pointer',
            color: this.chartproperties.dataLabelColor === 'default' 
              ? (this.chartproperties.darkTheme ? 'white' : 'black')
              : this.chartproperties.dataLabelColor  // ✅ label color
          })
          .on('mouseover', (e: MouseEvent) => {
            const tc = tooltipEl.querySelector('.inner-tooltip-content') as HTMLElement;
            if (tc) { tc.style.display = 'block'; tc.style.position = 'fixed';
              tc.style.left = (e.clientX + 10) + 'px'; tc.style.top = (e.clientY - 30) + 'px'; }
          })
          .on('mousemove', (e: MouseEvent) => {
            const tc = tooltipEl.querySelector('.inner-tooltip-content') as HTMLElement;
            if (tc) { tc.style.left = (e.clientX + 10) + 'px'; tc.style.top = (e.clientY - 30) + 'px'; }
          })
          .on('mouseout', () => {
            const tc = tooltipEl.querySelector('.inner-tooltip-content') as HTMLElement;
            if (tc) tc.style.display = 'none';
          })
          .add();
          if (this.innerCircleSigText) {
            chart.renderer.text(this.innerCircleSigText, centerX, centerY + 10)
              .attr({id: 'inner-circle-sig-' + self.id, align: 'center', zIndex: 5 })
              .css({ fontSize: sigLabelSize, color: this.innerCircleSigColor, cursor: 'default' })
              .add();
          }
        }, 100);
      }
    }
    else {
      localStorage.setItem("properties", JSON.stringify(this.chartproperties));
      HC_accessibility(Highcharts);
      let c = 0;
      let height = this.height;
      let chartimagepath = this.chartimagepath;
      let samplesizeconstant = this.samplesizeconstant;
      this.preparechartdata(jsondata, chartproperties.datalabelStyle == 'ls', chartproperties.gradientBarColor);
      const containerEl = document.getElementById(containerId);
      if (!containerEl) { return; }
      this.chart = Highcharts.chart(containerEl, {
        accessibility: {
          point: {
            valueSuffix: '%',
          },
        },
        chart: {
          type: 'pie',
          marginTop: -20,
          marginBottom: chartproperties.showLegend && chartproperties.legendPosition == "bottom" ? 90 : 0,
          spacing: [10, 10, chartproperties.showLegend && chartproperties.legendPosition == "bottom" ? 60 : 10, 10],
          backgroundColor: chartproperties.darkTheme ? '#333' : 'white',
          // events: {
          //   render: function () {
          //     const chart = this as any;
          //     let imageUrl = chartimagepath;
          //     // Check if the image is already added before rendering it again
          //     if (!chart.groupImage) {
          //       chart.groupImage = chart.renderer
          //         .image(
          //           imageUrl,
          //           chart.plotLeft + chart.plotWidth / 2 - 50 / 2,
          //           chart.plotTop + chart.plotHeight / 2 - 50 / 2,
          //           50,
          //           50
          //         )
          //         .attr({
          //           zIndex: 6,
          //           display: chartproperties.image ? 'block' : 'none',
          //         })
          //         .add();
          //     } else {
          //       // Update image position if it already exists
          //       chart.groupImage.attr({
          //         x: chart.plotLeft + chart.plotWidth / 2 - 50 / 2,
          //         y: chart.plotTop + chart.plotHeight / 2 - 50 / 2,
          //       });
          //     }

          //     // Check if the dotted border is already added before rendering it again
          //     let borderWidth = 1;
          //     let borderColor = chartproperties.darkTheme ? 'white' : '#333';
          //     let centerX2 = chart.plotLeft + (chart.plotWidth / 2) ;
          //     let centerY2 = chart.plotTop + (chart.plotHeight / 2) + 0;
          //     // let circleRadius = Math.min(chart.plotWidth, chart.plotHeight) / 6;
          //     let circleRadius="4em";
          //     if (!chart.dottedBorder) {
          //       chart.dottedBorder = chart.renderer
          //         .circle(centerX2, centerY2, circleRadius)
          //         .attr({
          //           fill: 'none',
          //           'stroke-width': borderWidth,
          //           stroke: borderColor,
          //           dashstyle: 'Dash',
          //           display: chartproperties.innerBorder ? 'block' : 'none',
          //         })
          //         .add();
          //     } else {
          //       // Update dotted border position if it already exists
          //       chart.dottedBorder.attr({
          //         cx: centerX2,
          //         cy: centerY2,
          //       });
          //     }
          //   },
          // },
          style: {
            fontFamily: this.piechartservice.fontFamily,
          }

        },
        title: {
          text: "",
          align: chartproperties.chartTitlePosition,
          verticalAlign: 'top',
          style: {
            color: chartproperties.darkTheme ? 'white' : 'black',
            fontSize: "2rem"
          },
        },
     legend: {
          navigation: {
            itemMarginLeft: 10,
            activeColor: '#7f7f7f',
            animation: true,
            arrowSize: 10,
            inactiveColor: '#ccc',
            enabled:this.popUp?true:false,
            style: {
              fontSize: '0.7em',
              color: chartproperties.darkTheme ? 'white' : '#333',
            }
          },
          enabled:true,
          // y:chartproperties.legendPosition == 'bottom'?0:4,
          maxHeight: this.popUp?chartproperties.legendPosition == 'bottom' ? 45 : 300:0,
          layout:
            chartproperties.legendPosition != 'bottom'
              ? 'vertical'
              : 'horizontal',
          x: this.popUp?chartproperties.legendPosition == 'right' ? 40 : 0  :0,
          y: this.popUp?chartproperties.legendPosition == 'bottom' ? 10 : 0 : 0,
          // width: height=='100%'?100:'100%',
            itemWidth:100, // Set legend item width (adjust as needed)
          align: chartproperties.legendPosition,
          verticalAlign:
            chartproperties.legendPosition != 'bottom' ? 'middle' : 'bottom',
          symbolWidth: 0,  // Set to a valid non-negative value
          symbolHeight: 0, // Set to a valid non-negative value
          //symbolWidth: -1,
          //symbolHeight: -1,
          useHTML: true,
          itemMarginTop: 0,    // Adjust this value to reduce the top margin
          // itemMarginLeft:-50,
          itemMarginBottom: -5,
          itemStyle: {
            fontWeight: "normal",
            // fontSize: '0.8em',
            fontSize:(0.8 * ((this.popUp || this.height === '100%') ? 1.45 : 1)) + 'em',
            cursor: 'pointer'
          },
            labelFormatter: function (): any {
              let point = this as any;
              let textcolor = chartproperties.darkTheme ? 'white' : 'black';
             
              if (point.color != "#eeebed" && point.color != "#7f7f7f") {
                let legendMarginBottom = (chartproperties.legendPosition === 'left' || chartproperties.legendPosition === 'right') ? 'margin-bottom:4px;' : '';
                return '<div style="display:flex;align-items:center;font-size:0.8em;' + legendMarginBottom + '" title="' + point.name + '">' 
                  + '<div style="display:flex;width:10px;height:10px;background-color:' + point.color + ';border-radius:50%"></div>'
                  + '<div style="width:' + (height != "100%" ? '20rem' : '29.5rem') + ';font-size:0.8em;padding-left:10px;padding-top:'+ (popUpState ? '1px' : '5px')+';color:' + textcolor + ';overflow:visible;white-space:normal;text-overflow:ellipsis;flex:1;line-height:1.2;" title="' + point.name + '">' + '   ' + point.name + '   ' + '</div>'
                  + '</div>';
              }
            },
        },
        plotOptions: {
          pie: {
          
             center: ['50%', '50%'], // Center the pie chart
            size: this.height === '100%' ? '100%' : (this.height === '11em' ? '95%' : '90%'), // Made even wider
             innerSize: this.height === '100%' ? '70%' : (this.height === '11em' ? '45%' : '60%'), // Dynamic inner size
    //     center: this.getResponsiveChartProps().center,
    // size: this.getResponsiveChartProps().size,
    // innerSize: this.getResponsiveChartProps().innerSize,
            showInLegend: chartproperties.showLegend,
            borderWidth: 3, // Add gap between pie slices
            borderColor: 'white', // White gap color (or use chart background color)
            borderRadius: 0, // Remove rounded edges
            depth: 1,
            shadow: chartproperties.shadow ? {
              color: 'rgba(0, 0, 0, 0.5)',
              offsetX: 1,
              offsetY: 1,
              opacity: 0.5,
              width: 6,
            } : false,
            dataLabels: {
              style: {
                fontSize: chartproperties.dataLabelSize,
                fontWeight: "normal",
              },
              allowOverlap: true,
              enabled: chartproperties.showDataLabel,
              color: chartproperties.dataLabelColor == "default" ? ((chartproperties.datalabelStyle == "bubble" && chartproperties.gradientBarColor && chartproperties.darkTheme) ? 'black' : chartproperties.darkTheme ? 'white' : 'black') : chartproperties.dataLabelColor,
              y: chartproperties.connector ? -10 : -10,
              formatter: function (this: Highcharts.TooltipFormatterContextObject): any {
                const pointWithMetric = this.point as {
                  name?: any;
                  parent?: any;
                  color?: any;
                  y?: number;
                  y1?: number;
                  cov?: string;
                  significance?: string;
                  samplesize?: number;
                  significance2?: any;
                  tooltip?: any
                };
                let textcolor = chartproperties.darkTheme ? "white" : "black";
                if (chartproperties.datalabelStyle === 'datalabel') {
                  let text = pointWithMetric.y1 != null ? pointWithMetric.y + (chartproperties.dataLabelFormat ? '%' : '') : "NA";
                  pointWithMetric.tooltip = text;
                  return (
                    '<span>' +
                    text +
                    '</span> ' +
                    '<span style="opacity: 0.5"></span>'
                  );
                }
                else if (chartproperties.datalabelStyle === 'change') {
                  let text = pointWithMetric.y1 != null ? pointWithMetric.y + (chartproperties.dataLabelFormat ? '%' : '') + ' ' + `<span span style="font-size: 80%;color:` + (chartproperties.darkTheme ? 'white' : 'black') + `">(` + (Number(pointWithMetric.cov) > 0 ? '+' : '') + `${pointWithMetric.cov} )</span>` : 'NA';
                  pointWithMetric.tooltip = text;
                  return (
                    '<span style="color:' + textcolor + ';">' + text + '</span>'
                  );
                } else if (chartproperties.datalabelStyle === 'significance + changeVs') {
                  const upwardTriangle = '\u25B2';
                  const downwardTriangle = '\u25BC';
                  let sig = Number(pointWithMetric.significance);
                  let s =
                    sig > 0 ? upwardTriangle : sig < 0 ? downwardTriangle : '';
                  let sigcolor = sig > 0 ? 'green' : sig < 0 ? 'red' : '';
                  let text = pointWithMetric.y1 != null ? pointWithMetric.y + (chartproperties.dataLabelFormat ? '%' : '') + ' ' + `<span span style="font-size: 80%;color:` + (chartproperties.darkTheme ? 'white' : 'black') + `">(` + (Number(pointWithMetric.cov) > 0 ? '+' : '') + `${pointWithMetric.cov} )</span>` + '<span style="color:' +
                    sigcolor +
                    ';">' +
                    s +
                    '</span>' : 'NA';
                  pointWithMetric.tooltip = text;
                  return (
                    '<span style="color:' +
                    textcolor +
                    ';">' +
                    text +
                    '</span>'
                  );
                }
                else if (chartproperties.datalabelStyle === 'significance') {
                  const upwardTriangle = '\u25B2';
                  const downwardTriangle = '\u25BC';
                  let sig = Number(pointWithMetric.significance);
                  let s =
                    sig > 0 ? upwardTriangle : sig < 0 ? downwardTriangle : '';
                  let sigcolor = sig > 0 ? 'green' : sig < 0 ? 'red' : '';

                  let text = pointWithMetric.y1 != null ? pointWithMetric.y + (chartproperties.dataLabelFormat ? '%' : '') + '<span style="color:' +
                    sigcolor +
                    ';">' +
                    s +
                    '</span>' : 'NA';
                  pointWithMetric.tooltip = text;
                  return (
                    '<span style="color:' +
                    textcolor +
                    ';">' +
                    text +
                    '</span>'
                  );
                }
                else if (chartproperties.datalabelStyle === 'ls') {
                  let text = Number(pointWithMetric.samplesize) > samplesizeconstant ? (pointWithMetric.y1 == null ? 'NA' : pointWithMetric.y + (chartproperties.dataLabelFormat ? '%' : '')) : 'LS';
                  pointWithMetric.tooltip = text;
                  return (
                    '<span>' +
                    pointWithMetric.name +
                    '</span>' + " " + '<span>' +
                    text +
                    '</span> ' +
                    '<span style="opacity: 0.5"></span>'
                  );
                }
                else if (chartproperties.datalabelStyle == "significance2") {
                  const upwardTriangle = '\u25B2';
                  const downwardTriangle = '\u25BC';
                  let text = pointWithMetric.y1 != null ? this.y + (chartproperties.dataLabelFormat ? '%' : '') : 'NA';
                  let changeText = pointWithMetric.cov;
                  let sig = pointWithMetric.significance;
                  let sig1 = pointWithMetric.significance2;
                  let sColor = Number(sig) > 0 ? 'green' : (Number(sig) < 0 ? 'red' : '');
                  let s = Number(sig) > 0 ? upwardTriangle : (Number(sig) < 0 ? downwardTriangle : '');
                  let changeColor = sig1 < 0 ? 'red' : (sig1 > 0 ? 'green' : (chartproperties.darkTheme ? 'white' : 'black'));
                  c++;

                  if (Number(changeText) > 0) {
                    changeText = "+" + changeText;
                  }
                  let text1 = '<span>' + text +
                    (pointWithMetric.y1 != null && changeText ? '&nbsp<span style="color:' + ';"> ' +
                      '<span style="font-size: 80%; color:' + changeColor + ';">(' + changeText + ')</span> &nbsp' +
                      '<span style="color:' + sColor + ';">' + s + '</span>' : '') +
                    '</span>'
                  pointWithMetric.tooltip = text1;
                  return (
                    text1
                  );
                }
              },
              connectorWidth: chartproperties.connector ? 1 : -0,
              connectorColor: null,
              connectorPadding: chartproperties.connector ? 20 : 0,
              distance: chartproperties.connector ? 20 : 0,
              useHTML: true,
              connectorShape: function (this: any, args: any): any {
                const directionMultiplier = args.alignment === 'right' ? -1 : 1;
                const extensionLength = 75;
                const endX = args.x + directionMultiplier * extensionLength;
                const endY = args.y;
                const angle = (this.shapeArgs.start + this.shapeArgs.end) / 2;
                const sliceEndX =
                  this.shapeArgs.x +
                  Math.cos(angle) * (this.shapeArgs.r + (args.depth || 0));
                const sliceEndY =
                  this.shapeArgs.y +
                  Math.sin(angle) * (this.shapeArgs.r + (args.depth || 0));
                const path = [
                  ['M', sliceEndX, sliceEndY],
                  ['L', args.x, args.y],
                  ['L', endX, endY],
                ];

                return path;
              },
            },
          },
        },
           tooltip: {
          enabled: true,
          borderWidth: 1,
          useHTML: true,
          shape: 'square',
          shadow: false,
          backgroundColor:  'white',  
          outside:true,
          style: {
            fontSize: '0.8rem'
          },
          formatter: function (this: any): any {
            const pointWithMetric = this.point as {
              name?: any;
              parent?: any;
              color?: any;
              actualcolor?: any;
              y?: number;
              y1?: number;
              cov?: string;
              significance?: string;
              significance2?: string;
              samplesize?: number;
              tooltip?: any;
              Significance_Value?: any;
            };
            if (pointWithMetric.color === '#eeebed' || pointWithMetric.color === '#7f7f7f') { return false };
            const backgroundcolor = chartproperties.darkTheme ? '#b3b3b3' : '#f5f5f5';
            const backgroundcolor2 = chartproperties.darkTheme ? '#dddddd' : 'white';
            if (pointWithMetric.tooltip == "") { pointWithMetric.tooltip = pointWithMetric.y1 == null ? 'NA' : pointWithMetric.y }

            let isDefaultTooltip = chartproperties.toolTipStyle;
            if (isDefaultTooltip == "style1") {
              const dotColor = pointWithMetric.color;
              this.point.series.tooltipOptions.borderColor = dotColor;
              this.point.series.tooltipOptions.borderWidth=10;
             const content =
    `<div class="high-z-tooltip" style="background: #fff;  min-width: 220px; font-size: 0.8em; display: flex; box-shadow: none;align-items: center;z-index:999 !important;padding:2px;">
      <span style=" width:10px; height:10px; border-radius:50%; background:${dotColor}; margin-right:8px; vertical-align:middle;"></span>
      <span>${pointWithMetric.name}: </span>
      <b style="margin-left:4px;">${pointWithMetric.tooltip}</b>
    </div>`;
  return content;
              return content + '</div>';
            }
            else if (chartproperties.datalabelStyle === 'sigChange') {

            }
            else {
              const dotColor = pointWithMetric.color; // Get the series color

             
                const commonContent =
                `<div style="border-left: 2px solid ` + dotColor + `;font-size:0.7em; border-bottom: 2px solid ` + dotColor + `; z-index: 100; padding: 5px; border-radius: 5px; margin: 0px; background-color :${backgroundcolor2};">` +
                // `<span style="display: block; text-align: center; color: `+dotColor+`; font-weight: bold; font-size: 12px;">Tooltip Title</span>` +
                // `<span><strong>Series Name:</strong></span>Brands<br>` +
                ` ${pointWithMetric.name} : ` +
                `${pointWithMetric.tooltip}`;
              return commonContent + '</div>';

            }



          },
        },
        series: this.seriesdata,
        credits: {
          enabled: false,
        },
        exporting: {
          enabled: false
        }
      } as any);
    }
  }

  applycustomization(event: any, item: string) {
    //choose the appropriate customization
    this.piechartservice.applycustomization(event, item, this.chartproperties)
    this.plotChart('chart-container' + this.id, this.jsondata['data'], this.chartproperties);
  }

  userselectedproperties() {
    // this.jsondata['data']=this.jsondata['data'].slice(0,10);
    this.jsondata['properties'][0] = this.chartproperties;
    return JSON.stringify(this.jsondata).toString();
  }

  private updateSigSub: Subscription | null = null;

  ngOnDestroy(): void {
    this.updateSigSub?.unsubscribe();
    this.subscriptions.unsubscribe();
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }
  }
}

